export default __webpack_public_path__ + "static/media/Boots of the Defiant.4ce2c783.jpg";